import { PRICING_PAGE } from "@/lib/constants";

export default function ValueComparison() {
  const { valueComparison } = PRICING_PAGE;

  return (
    <section
      data-testid="value-comparison-section"
      className="bg-white py-12 md:py-20"
      aria-label="Value comparison"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A] tracking-tight mb-4">
            {valueComparison.heading}
          </h2>
          <p className="text-[#6B7280] text-base leading-relaxed">
            {valueComparison.subheading}
          </p>
        </div>

        {/* Comparison list */}
        <div
          data-testid="value-comparison-table"
          className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm"
        >
          {valueComparison.items.map((item, i) => (
            <div
              key={item.tool}
              data-testid={`value-row-${i}`}
              className={`flex items-center justify-between px-5 md:px-6 py-4 ${
                i % 2 === 0 ? "bg-white" : "bg-[#F9FAFB]"
              } ${i < valueComparison.items.length - 1 ? "border-b border-gray-100" : ""}`}
            >
              <div className="flex-1 min-w-0">
                <span className="text-sm font-semibold text-[#1A1A1A] block">
                  {item.tool}
                </span>
                <span className="text-xs text-[#6B7280] hidden sm:block">
                  {item.desc}
                </span>
              </div>
              <span className="text-sm font-semibold text-[#1A1A1A] ml-4 shrink-0">
                {item.cost}
              </span>
            </div>
          ))}

          {/* Total row */}
          <div
            data-testid="value-total-row"
            className="flex items-center justify-between px-5 md:px-6 py-4 bg-[#1A1A1A]"
          >
            <span className="text-sm font-bold text-white">
              Total if purchased separately:
            </span>
            <span className="text-lg font-extrabold text-white">
              {valueComparison.total}
            </span>
          </div>
        </div>

        {/* Savings highlight */}
        <div
          data-testid="value-savings-box"
          className="mt-6 bg-[#D8FFB8]/30 border-2 border-[#20611B]/20 rounded-xl p-6 md:p-8 text-center"
        >
          <p className="font-heading text-xl md:text-2xl font-bold text-[#20611B] mb-1">
            With Epsillon Leads: {valueComparison.epsillonPrice}
          </p>
          {valueComparison.epsillonTotal && (
            <p className="font-heading text-2xl md:text-3xl font-extrabold text-[#20611B] mb-2">
              {valueComparison.epsillonTotal}
            </p>
          )}
          <p className="text-lg font-semibold text-[#D4A84B]">
            You save {valueComparison.savings} every month compared to buying tools separately.
          </p>
        </div>
      </div>
    </section>
  );
}
